export const hidenMessageAPI = [
  "user-preferences-general",
  "profile",
  "/auth/login/",
  "/auth/token-refresh/",
  "/rajnagar_gyanmahostav/student-video-submissions/",
  "/rajnagar_gyanmahostav/teachers/",
  "/rajnagar_gyanmahostav/topics/",
  "/rajnagar_gyanmahostav/pathshalas/",
];
